import DepartureList from './container'

export default DepartureList
